import { logoImage } from '../constants/images'
import { BASIC_ROUTE } from '../constants/pages-routes'
import { cn } from '../lib/utils'
import { cva, VariantProps } from 'class-variance-authority'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

const logoVariants = cva(
    "",
    {
        variants: {
            size: {
                default: "w-[130px] md:w-[200px]",
                sm: "w-[100px] md:w-[130px]",
            },
        },
        defaultVariants: {
            size: "default",
        },
    }
)

type LogoProps = VariantProps<typeof logoVariants> & {
    className?: string,
}

function Logo({ size, className }: LogoProps) {
    return (
        <Link href={BASIC_ROUTE.home}>
            <Image
                src={logoImage}
                alt="Logo"
                className={cn(logoVariants({ size }), className)}
                priority
            />
        </Link>
    )
}

export default Logo